<template>
  <v-card>
    <v-row class="news-wrapper no-gutters">
      <v-col :cols="$vuetify.breakpoint.xs ? 12 : 9">
        <fin-data-loader :resolver="loadData">
          <template v-if="newsItems" #content>
            <fin-news-list :items="newsItems"
                           :show-item-teaser="false"
                           class="px-4 pt-2"/>
          </template>
        </fin-data-loader>
      </v-col>
      <v-col v-if="$vuetify.breakpoint.smAndUp" align="right" class="pa-3" cols="3">
        <v-img :max-width="175"
               :src="require('@/assets/myFinHub/tool-news.svg')"
               contain/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {searchNewsTeasers} from "@/js/finQueries"
import FinDataLoader from "@/components/common/DataLoader"
import FinNewsList from "@/components/pages/finNews/newsList"

export default {
  name: 'fin-news-view',
  components: {
    FinNewsList,
    FinDataLoader
  },
  data() {
    return {
      newsItems: null
    }
  },
  methods: {
    async loadData() {
      API.graphql(graphqlOperation(searchNewsTeasers, {
        limit: 5,
      })).then(result => {
        this.newsItems = result.data.searchNewsArticles.items
      }).catch(error => {
        console.error("error loading Dashboard news articles", error)
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.news-wrapper {
  background-color: $fin-color-primary-light;
}


</style>
